import type { SwitchContext } from './switch.types'

import { createContext } from '../utils'

const [SwitchProvider, useSwitchContext] = createContext<SwitchContext>({ isOptional: true })

export { SwitchProvider, useSwitchContext }
